import { Id } from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import { ToolsResponse as Response } from 'tools/queries/shared/response'
import { convertTools } from './shared/convert'
import keys from './shared/keys'
import { ToolsData } from './shared/types'

export function useTools(storeId: Id | undefined) {
  const { server } = useServer()
  return useQuery<ToolsData>({
    queryKey: storeId ? keys.list(storeId) : [],
    queryFn: fetchTools,
  })

  async function fetchTools() {
    const response = await server.get<Response.Tools>(
      `/v2/managers/me/tools?store_id=${storeId}`
    )

    return convertTools(response)
  }
}
